import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { TargetsContext } from "../../contexts";
import { LatencyDetail } from "./LatencyDetail";
import { JitterDetail } from "./JitterDetail";
import { ShadowBox } from "../common";
import { LatencyChart, JitterChart, Location } from "../common";
import { GoToButton } from "./GoToButton";
import useAds from "../../hooks/UseAds";
import { AboutLatency } from "./AboutLatency";
import { AboutJitter } from "./AboutJitter";
import { AboutLatencyChart } from "./AboutLatencyChart";
import { AboutJitterChart } from "./AboutJitterChart";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import start from "../../assets/img/start.gif";

export const Detail = () => {
  const { index } = useParams();
  let targets = useContext(TargetsContext);
  useAds();

  if (!targets || !targets[index]) return null;

  /** Render.
   *
   */
  return (
    <>
      <Row className='justify-content-between align-items-center my-4'>
        <Col>
          <Location index={index} />
        </Col>
        {/* <Col className='text-end'>
          <GoToButton></GoToButton>
        </Col> */}
      </Row>
      <Row>
        <Col>
          <Row className='g-0 mb-2'>
            <Col className='col-auto'>
              <span className='text-dark h4 me-2'>Latency</span>
            </Col>
            <Col className='col-auto'>
              <AboutLatency />
            </Col>
          </Row>
          <ShadowBox className='p-2'>
            <div>
              <LatencyDetail index={index}></LatencyDetail>
            </div>
            <div>
              <LatencyChart index={index}></LatencyChart>
            </div>
            <AboutLatencyChart className='pb-2' targetIndex={index} />
          </ShadowBox>
        </Col>
        <Col>
          <Row className='g-0  mb-2'>
            <Col className='col-auto'>
              <span className='text-dark h4 me-2'>Jitter</span>
            </Col>
            <Col className='col-auto'>
              <AboutJitter></AboutJitter>
            </Col>
          </Row>
          <ShadowBox className='p-2'>
            <div>
              <JitterDetail index={index} />
            </div>
            <div>
              <JitterChart index={index}></JitterChart>
            </div>
            <AboutJitterChart className='pb-2' targetIndex={index} />
          </ShadowBox>
        </Col>
      </Row>
      <div class='divider div-transparent div-arrow-down'></div>
      <Row className='mt-4'>
        <h2>Discover Your Latency on a Global Scale</h2>
        <p>Only takes 30 seconds</p>

        <Link id='begin-global-speed-test' to={`/global-testing`}>
          <img src={start} className='img-fluid' alt='...' />
        </Link>
      </Row>
    </>
  );
};
